import styled from "styled-components";

export const CTAContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  background: #ffffff;
  border-top: 1px solid #e9eaeb;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);

  padding: 32px 0;
  text-align: center;

  @media (min-width: 992px) {
    padding: 40px 0;
  }

  @media (max-width: 576px) {
    padding: 24px 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 0 16px;
`;

export const Title = styled.h3`
  margin: 0 auto 12px auto;
  color: rgba(10, 13, 18, 0.9);
  text-align: center;
  font-family: inherit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;

  @media (max-width: 576px) {
    font-size: 18px;
    line-height: 26px;
  }
`;

export const SubTitle = styled.p`
  margin: 0 auto 24px auto;
  color: rgba(10, 13, 18, 0.6);
  text-align: center;
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const PrimaryButton = styled.button`
  margin: 0 auto;
  display: flex;

  justify-content: center;
  align-items: center;
  gap: 6px;

  width: 100%;
  max-width: 300px;

  padding: 10px 16px;
  align-self: stretch;

  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  background: #2258f1;
  cursor: pointer;
  outline: none;

  box-shadow: 0 2px 2px 0 rgba(255, 255, 255, 0.35) inset,
    0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  color: #ffffff;
  font-size: 16px;
  font-weight: 600;

  transition: background 0.2s ease-in-out;

  &:hover {
    background: #1f4ed0;
  }

  @media (max-width: 576px) {
    max-width: 100%;
  }
`;

export const SecondaryLinkText = styled.p`
  margin: 16px 0 0 0;
  font-size: 14px;
  line-height: 20px;
  color: #475467;
`;

export const SecondaryLink = styled.button`
  background: transparent;
  border: none;
  color: #2258f1;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  margin-left: 4px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
